import styled from 'styled-components';

export interface IHistoryPanelProps {
  open?: boolean;
}

export const BidHistoryPanel = styled.div<IHistoryPanelProps>`
    background: #181C21;
    position: absolute;
    margin-left: auto;
    bottom: 0;
    opacit: ${(prop) => (prop.open ? 'block' : 'none')};
    display: ${(prop) => (prop.open ? 'block' : 'none')};
    width: 100%;
    height: 15rem;
    z-index: 10000;
    -webkit-transition: top 5s, bottom 5s;
  
    .vertical-timeline-element {
      margin-bottom: 0;
    }
  
    .vertical-timeline.vertical-timeline-custom-line::before {
      width: 1px;
      background: #424242;
      height: 100%;
    }
  
    .vertical-timeline-element-content {
      position: relative;
      margin-left: 60px;
      background: #fff;
      border-radius: .25em;
      padding: 1em;
      -webkit-box-shadow: initial;
      box-shadow: initial;
    }
  
    .vertical-timeline.vertical-timeline-custom-line
      .vertical-timeline-element--accepted
      .vertical-timeline-element-icon {
      width: 12px;
      height: 12px;
      left: 2.55%;
      box-shadow: 0 0 0 3px #7dbc55, inset 0 2px 0 rgba(0, 0, 0, 0.08),
        0 1px 0 2px rgba(0, 0, 0, 0.05);
    }
  
    .vertical-timeline.vertical-timeline-custom-line
    .vertical-timeline-element--rejected
    .vertical-timeline-element-icon {
      width: 12px;
      height: 12px;
      left: 2.55%;
      box-shadow: 0 0 0 3px #E44A4D, inset 0 2px 0 rgba(0, 0, 0, 0.08),
        0 1px 0 2px rgba(0, 0, 0, 0.05);
    }
  
    .vertical-timeline.vertical-timeline-custom-line
    .vertical-timeline-element--open
    .vertical-timeline-element-icon {
      width: 12px;
      height: 12px;
      left: 2.55%;
      box-shadow: 0 0 0 3px #7F7F7F, inset 0 2px 0 rgba(0, 0, 0, 0.08),
        0 1px 0 2px rgba(0, 0, 0, 0.05);
    }
  
    .vertical-timeline-element-content
    {
      padding: 0;  
      margin-left: 35px;
    }
  
    .vertical-timeline-element-content .vertical-timeline-element-date {
      padding-bottom: 0em;
    }
  
    .vertical-timeline-element-date {
      position: absolute;
      left: 63.37%;
      right: 1.65%;
      bottom: .44%;
  
      /* label/normal */
  
      font-family: Avenir Next;
      font-size: 12px;
      line-height: 14px;
      color: #A6A6A6
      padding-bottom: 0 !important;
    }
  
    .vertical-timeline-element-content .vertical-timeline-element-title--accepted
    {
      font-family: Avenir Next;
      font-size: 12px;
      line-height: 14px;
      color: #7DBC55;
      font-weight: 500
    }
  
    .vertical-timeline-element-content .vertical-timeline-element-title--open
    {
      font-family: Avenir Next;
      font-size: 12px;
      line-height: 14px;
      color: #A6A6A6;
      font-weight: 500
    }
  
    .vertical-timeline-element-content .vertical-timeline-element-title--rejected
    {
      font-family: Avenir Next;
      font-size: 12px;
      line-height: 14px;
      color: #E44A4D;
      font-weight: 500
    }
  `;

export interface IBidHistoryPanelContainerProps {}

export const BidHistoryPanelContainer = styled.div<
  IBidHistoryPanelContainerProps
>`
  height: 12rem;
  overflow-x: auto;

  ::-webkit-scrollbar {
    width: 5px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #363537;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #d9d9d9;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

export interface IBidHistoryPanelHeaderTitleProps {}

export const BidHistoryPanelHeaderTitle = styled.div<
  IBidHistoryPanelHeaderTitleProps
>`
  flex: 1;
  padding-left: 1rem;
  font-family: Avenir Next;
  font-size: 16px;
  line-height: 24px;
`;

export interface IHistoryPanelHeaderProps {}

export const BidHistoryPanelHeader = styled.div<IHistoryPanelHeaderProps>`
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  display: flex !important;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  .crossIcon {
    margin-right: 1.75rem;
    cursor: pointer;
  }
`;
